import React from 'react';
import styled from 'styled-components'
import {Linkedin , Github ,Chat} from 'grommet-icons'
import {Link} from 'react-router-dom'


const WrapperIcons = styled.div`
@media (min-width:1025px) {
    position:fixed;
    bottom:20px;
    
}


@media (min-width:1650px) {
    position:fixed;
    bottom:20px;
    display:grid;
    grid-gap:100px;
    grid-template-columns: repeat(3,auto);
}
`


const SingleIcon = styled.image`
transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
width:fit-content;

&:hover{
    background:#EAE1E1;
    transform: translateY(10px) rotate(90px);
    
}
`

const SocialButtons = () => {
    return (  
        <WrapperIcons>
            <SingleIcon><a target="_blank"href='https://www.linkedin.com/in/marcomoi/'><Linkedin size='large' color='white' style={{margin:'20px'}}/></a></SingleIcon>
            <SingleIcon><a target="_blank"href='https://github.com/iizMerk'><Github size='large' color='white' style={{margin:'20px'}}/></a></SingleIcon>
            <SingleIcon><a target="_blank"href='http://m.me/markolachow'><Chat size='large' color='white' style={{margin:'20px'}}/></a></SingleIcon>
        </WrapperIcons>
    );
}
 //http://m.me/markolachow
export default SocialButtons;